export default __webpack_public_path__ + "static/media/google.f27d1ab1.svg";